import { render, staticRenderFns } from "./ModalViewPassCode.vue?vue&type=template&id=2ab6843e&scoped=true&"
import script from "./ModalViewPassCode.vue?vue&type=script&lang=ts&"
export * from "./ModalViewPassCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewPassCode.vue?vue&type=style&index=0&id=2ab6843e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6843e",
  null
  
)

export default component.exports